export const environment = {
  apiUrl: 'https://api.staging.schenkwerk.com/api',
  stripePublishableKey:
    'pk_test_51RL82pP79iH5NSipBIutH0Lw0L0vEA9yrFmw8Un9XqIA0xqPfgwEM1wkj1YEnaRfHXtngDf9tO4YahG1RsNELEaz00KcJUfOMa',
  frontendUrl: 'https://app.staging.schenkwerk.com',
  dashboardUrl: 'app.staging.schenkwerk.com', // Dashboard hostname for staging
  storefrontBaseDomain: 'staging.schenkwerk.com', // Base domain for storefronts in staging
  protocol: 'https://',
  voucherScriptUrl: 'https://cdn.schenkwerk.com/qa-schenkwerk-voucher.js',
  googleClientId: '578927046794-22sdtdoqj6tddk99cf8u5bbgpqmr8jgi.apps.googleusercontent.com', // OAuth 2.0 Web client ID from Google Cloud Console (Sign in with Google)
  env: 'qa' as 'dev' | 'qa' | 'prod',
  debug: false, // Disable debug logging in staging by default
};
